<script setup lang="ts">
import { useFormStore } from '@/stores/form'
const formStore = useFormStore()
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()

const gotologin = () => {
  formStore.switchForm('login')
}
async function doLogout(){
  await userStore.logout(userStore.account)
  userStore.isLoggedIn= false 
  formStore.switchForm('login')
}
const gotoVideo = ()=>{
  formStore.switchForm('video')
}
const gotoHelp = () => {
  formStore.switchForm('help')
}
const gotoEditUser = () => {
  formStore.switchForm('edituser')
}
const gotoTrf = () => {
  formStore.switchForm('transfer')  
}
const gotoTrfCompanyNo = () => {
  formStore.switchForm('CompanyTr')  
}

const gotoTrfRecode = ()=>{
  formStore.switchForm('trfRecode')
}

const gotoMR = ()=>{
  formStore.switchForm('MustRead')
}

</script>

<template>
  <div class="Menutext">    
    <h3>系統選單</h3>
    <hr>
    <a @click="gotoMR"><h5>註冊教學</h5></a>
    <hr>
    <a v-if="userStore.isLoggedIn" @click="doLogout"><h5>系統登出</h5></a>
    <a v-if="!userStore.isLoggedIn" @click="gotologin"><h5>系統登入</h5></a>
    
    <a v-if="userStore.isLoggedIn" @click="gotoVideo"><h5>錄影工作</h5></a>
    <!-- 以下會根據 isLoggedIn 顯示 -->
    <!-- <a v-if="userStore.isLoggedIn" @click="gotoTrf"><h5>匯款儲值</h5></a> -->
    <a @click="gotoTrf"><h5>匯款儲值</h5></a>
    <a v-if="userStore.isLoggedIn" @click="gotoTrfCompanyNo"><h5>相關帳號</h5></a>  
    <a v-if="userStore.isLoggedIn" @click="gotoTrfRecode"><h5>匯款查詢</h5></a>  
    <a v-if="userStore.isLoggedIn" @click="gotoEditUser"><h5>修改資料</h5></a>
    
    <!-- <a v-if="userStore.isLoggedIn" @click="gotoHelp"><h5>協助</h5></a> -->
      
    


    
  </div>
</template>


<style scoped>
h3{
  color: rgb(83, 81, 81);
}
.Menutext {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  vertical-align: top; 
  color: rgb(240, 233, 237);
  font-size: 22px;
  
  margin: 0;            /* 取消外距 */
  padding: 10px 20px;   /* 可加一點內距讓內容不貼邊 */
}


.Menutext a h5 {
  margin: -10px;
  padding: 10px;
}

.Menutext a {
  color: deeppink;
  font-size: 22px;
  text-decoration: none;
  cursor: pointer;
  margin: 10px;
}
</style>
